import script from "./DualRangeSlider.vue?vue&type=script&setup=true&lang=js"
export * from "./DualRangeSlider.vue?vue&type=script&setup=true&lang=js"

import "./DualRangeSlider.vue?vue&type=style&index=0&id=2d01e735&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d01e735"]])

export default __exports__